import React, { useEffect, useRef, useState } from 'react';
import { IconClock } from '@tabler/icons-react';
import classes from '../css/ExamDashboardPage.module.css';

interface DashboardExamTimerProps {
  remainingSeconds: number;
  onFinish?: () => void;
  label?: string;
}

export const DashboardExamTimer: React.FC<DashboardExamTimerProps> = ({
  remainingSeconds,
  onFinish,
  label = 'Starts in',
}) => {
  const [secondsLeft, setSecondsLeft] = useState(remainingSeconds);
  const onFinishRef = useRef(onFinish);

  useEffect(() => {
    onFinishRef.current = onFinish;
  }, [onFinish]);

  useEffect(() => {
    setSecondsLeft(remainingSeconds);
  }, [remainingSeconds]);

  useEffect(() => {
    if (secondsLeft <= 0) return;

    const interval = setInterval(() => {
      setSecondsLeft((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          // Defer to avoid setState during render
          setTimeout(() => onFinishRef.current?.(), 0);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [remainingSeconds]);

  if (secondsLeft <= 0) return null;

  const formatTime = (totalSeconds: number) => {
    const hours = Math.floor(totalSeconds / 3600);
    const mins = Math.floor((totalSeconds % 3600) / 60);
    const secs = totalSeconds % 60;

    const parts = [];
    if (hours > 0) parts.push(hours.toString().padStart(2, '0'));
    parts.push(mins.toString().padStart(2, '0'));
    parts.push(secs.toString().padStart(2, '0'));

    return parts.join(':');
  };

  return (
    <div className={classes.dashboardTimer}>
      <IconClock size={16} stroke={2} />
      <span>
        {label}: <strong>{formatTime(secondsLeft)}</strong>
      </span>
    </div>
  );
};
